import { TaskListType } from '@akin-home/amplify';
import {
  DashboardWidgetType,
  DashboardWidgetUnion,
} from '@akin-home/dashboards';
import Text from '../../components/Text';
import StickyNoteDashboardTile from '../../sticky-notes/components/StickyNoteDashboardTile';
import { AppWidget } from '../AppWidget';
import { CameraWidget } from '../CameraWidget';
import ChecklistPanel from '../ChecklistPanel';
import ContactsPanel from '../ContactsPanel';
import { DashboardMealsPanel } from '../DashboardMealsPanel';
import { DashboardProfilePanel } from '../DashboardProfilePanel';
import EventDetails from '../EventDetails';
import GoalDetails from '../GoalDetails';
import ImageDashboardPanel from '../ImagePanel/ImageDashboardPanel';
import { PhoneWidget } from '../PhoneWidget';
import { TimerDashboardPanel } from '../TimerDashboardPanel';
import TodaysEvents from '../TodaysEvents';
import TodaysGoals from '../TodaysGoals';
import TodaysGoalsSingle from '../TodaysGoalsSingle';
import { WeatherDashboardWidget } from '../WeatherDashboardWidget';

interface Props {
  widget: DashboardWidgetUnion;

  width: number;
  height: number;
}

const default_checklist_types: TaskListType[] = [
  TaskListType.Shopping,
  TaskListType.Checklist,
  TaskListType.ToDo,
];

export const DashboardTileContent = (props: Props) => {
  const { widget, width, height } = props;

  const small = width < 500;

  switch (widget.type) {
    case DashboardWidgetType.CHECKLISTS:
      return (
        <ChecklistPanel
          types={widget.data?.types || default_checklist_types}
          small={small}
        />
      );
    case DashboardWidgetType.CONTACTS:
      return <ContactsPanel small={small} />;
    case DashboardWidgetType.NEXT_EVENT:
      return <EventDetails />;
    case DashboardWidgetType.GOAL_LIST:
      return <TodaysGoals />;
    case DashboardWidgetType.GOAL_DETAILS:
      return <GoalDetails />;
    case DashboardWidgetType.TODAY_SCHEDULE:
      return <TodaysEvents />;
    case DashboardWidgetType.PROFILE:
      return <DashboardProfilePanel />;
    case DashboardWidgetType.IMAGE:
      return <ImageDashboardPanel widget={widget} />;
    case DashboardWidgetType.GOAL_CAROUSEL:
      return <TodaysGoalsSingle width={width} small={small} />;
    case DashboardWidgetType.STICKY_NOTE:
      return <StickyNoteDashboardTile width={width} />;
    case DashboardWidgetType.TIMER:
      return <TimerDashboardPanel small={small} />;
    case DashboardWidgetType.APP:
      return <AppWidget widget={widget} />;
    case DashboardWidgetType.PHONE:
      return <PhoneWidget size={Math.min(width, height) - 30} />;
    case DashboardWidgetType.CAMERA:
      return <CameraWidget size={Math.min(width, height) - 30} />;
    case DashboardWidgetType.MEALS:
      return <DashboardMealsPanel small={small} />;
    case DashboardWidgetType.WEATHER:
      return <WeatherDashboardWidget />;
    default:
      return <Text>{widget.type}</Text>;
  }
};
